import React, { useEffect } from 'react';
import SliderNav from './slider/sliderNav';
import SliderPagination from './slider/sliderPagination';
import QuarterSvg from './svg/quarterSvg';
import QuoteSvg from './svg/quoteSvg';

// @ts-ignore
import SwiperPhotographs from 'legacyJs/swiper-photographs';
import { FrontPhotographerMessages } from '../page/photographer/photographerPageTranslations';
import { ShText } from '@shoootin/translations';
import AppImage from '../primitives/appImage';

type QuarterProps = React.ComponentProps<typeof QuarterSvg>;
const useSliderPhotographersLegacyJs = () => {
  useEffect(() => {
    new SwiperPhotographs('.slider-photographs');
  }, []);
};

const Testimonials = [
  {
    text: FrontPhotographerMessages.testimonial1Text,
    name: FrontPhotographerMessages.testimonial1Name,
    city: FrontPhotographerMessages.testimonial1City,
    photo: require('images/about/sila.png'),
  },
  {
    text: FrontPhotographerMessages.testimonial2Text,
    name: FrontPhotographerMessages.testimonial2Name,
    city: FrontPhotographerMessages.testimonial2City,
    photo: require('images/about/sebastien.png'),
  },
  {
    text: FrontPhotographerMessages.testimonial3Text,
    name: FrontPhotographerMessages.testimonial3Name,
    city: FrontPhotographerMessages.testimonial3City,
    photo: require('images/about/aurelie.png'),
  },
  {
    text: FrontPhotographerMessages.testimonial4Text,
    name: FrontPhotographerMessages.testimonial4Name,
    city: FrontPhotographerMessages.testimonial4City,
    photo: require('images/about/gianluca.png'),
  },
];

const SliderPhotographs = ({
  quarterMode = 'solid',
}: {
  quarterMode?: QuarterProps['mode'];
}) => {
  useSliderPhotographersLegacyJs();
  return (
    <div className="slider-photographs">
      <div className="slider-photographs__slider">
        {Testimonials.map((testimonial, i) => (
          <figure key={i} className="slider-photographs__slide">
            <div className="slider-photographs__wrapper">
              <AppImage src={testimonial.photo} lazy />
              <figcaption className="slider-photographs__caption">
                <p className="slider-photographs__text">
                  <ShText message={testimonial.text} />
                </p>
                <p className="slider-photographs__title">
                  <b>
                    <ShText message={testimonial.name} />,
                  </b>{' '}
                  <ShText message={testimonial.city} />
                </p>
                <QuoteSvg />
              </figcaption>
              <div className="slider-photographs__mobile">
                <p className="slider-photographs__text">
                  <ShText message={testimonial.text} />
                </p>
                <QuoteSvg />
              </div>
            </div>
          </figure>
        ))}
      </div>
      <SliderNav />
      <SliderPagination count={Testimonials.length} />
      <div className="slider-photographs__quarter" data-parallax="0.2">
        <QuarterSvg mode={quarterMode} />
      </div>
    </div>
  );
};

export default SliderPhotographs;
